export default {
  wrapper: {
    position: 'relative',
  },
}
